import { render, staticRenderFns } from "./AttendanceStudentEdit.vue?vue&type=template&id=b661f200"
import script from "../../../controllers/custom/attendance_student/attendance-student-edit.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/attendance_student/attendance-student-edit.js?vue&type=script&lang=js&external"
import style0 from "./AttendanceStudentEdit.vue?vue&type=style&index=0&id=b661f200&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports